/**
 * Created by Ning Jiang on 2021-06-28.
 */

import {WinPresentationController} from "../WinPresentationController";
import {TimelineLite, TweenLite} from "gsap";
import {ElGordosRevenge} from "../../ElGordosRevenge";
import {ElGordosRevengeSymbolState} from "../../symbol/ElGordosRevengeSymbolConfig";
import {EGRS1Symbol} from "../../symbol/EGRS1Symbol";
import {EGRReelSplitSymbol} from "../../symbol/EGRReelSplitSymbol";
import {ElGordosRevengeLayers, Layers} from "../../view/ElGordosRevengeLayers";
import {ElGordosRevengeSound} from "../../sound/ElGordosRevengeSound";
import {ElGordosRevengeBackground} from "../../view/ElGordosRevengeBackground";

export class S1ToWRSTransformController extends WinPresentationController {

    constructor() {
        super("S1ToWRSTransformController", false);
    }

    protected hasWin():boolean {
        return ElGordosRevenge.model.parsedGameData.reelSplit.some(p => p > -1);
    }

    protected async createWinAnimation():Promise<any> {
        ElGordosRevenge.playScattersWin = true;
        const tl = new TimelineLite();
        let isFirst = true;
        ElGordosRevenge.model.parsedGameData.reelSplit.forEach((symId, reelId) => {
            if(symId > -1) {
                const reel = ElGordosRevenge.reels[reelId];
                const newSym = new EGRReelSplitSymbol(reelId, ElGordosRevengeSymbolState.NORMAL);
                const oldSym = <EGRS1Symbol>reel.getSymbol(symId);
                const globalPosition = oldSym.getGlobalCenterPosition();
                newSym.position.set(globalPosition.x, globalPosition.y);
                const symTl = new TimelineLite();
                // if(isFirst) {
                //     symTl.add(() => {
                //         ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.S1_WIN});
                //     });
                // }
                symTl.add(() => {oldSym.playWin()});
                if(isFirst) {
                    symTl.add(() => {
                        ElGordosRevengeBackground.shakeStageOnce(0.4);
                        ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.SCATTER_TO_WILD});
                    }, 0);
                }
                isFirst = false;
                symTl.add([
                    () => {
                        ElGordosRevengeLayers.getLayer(Layers.WIN_PRESENTATIONS)!.addChild(newSym);
                        newSym.visible = false;
                    },
                    newSym.playLanding(),
                    TweenLite.to(this, 0.2, {
                        onComplete : () => {
                            oldSym.visible = false;
                            newSym.visible = true;
                        }
                    })
                ]);
                symTl.add(() => {
                    newSym.position.set(oldSym.x, oldSym.y);
                    reel.reelView.addSymbol(newSym);
                    reel.reelView.allSymbols[reel.reelView.allSymbols.indexOf(oldSym)] = newSym;
                    reel.reelView.removeSymbol(oldSym);
                    oldSym.onRemove();
                });
                tl.add(symTl, 0);
            }
        });

        await Promise.resolve(tl);
    }
}